import { useEffect, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import Validate from "ressources/validation";
import { getNextSibling } from "utils/dom";
import images from "ressources/images";
import InsCheckbox from "components/InsCheckbox/InsCheckbox";

const ConnectOptin = ({
    optins,
    updateOptins,
    updateNewsletter,
    updateValidConsent,
    required,
    config,
    t,
}) => {
    const [gdpr, setGdpr] = useState(config.country === "SPAIN");
    const [cgu_espana, setCguEspana] = useState(false); // SPE ESPAGNE
    const [newsletterPopupOpen, setNewsletterPopupOpen] = useState(false)
    const [newsletterPopupText, setNewsletterPopupText] = useState("")

    /**
     * Ferme la popup voir plus
     */
    const closePopup = () => {
        setNewsletterPopupOpen(false)
    }

    /**
     * click sur une checkbox custom
     */
    const clickOptin = (optin) => (event) => {
        handleOptin(optin.id)(event);
        validateOptinField(optin.id)();
    };

    /**
     * Met à jour une optin
     */
    const handleOptin = (input) => (e) => {
        if (input === "gdpr") {
            setGdpr(e.target.checked);
        }
        // SPE ESPAGNE
        else if (input === "cgu_espana") {
            setCguEspana(e.target.checked);
        } else {
            const index = optins.findIndex((el) => el.id === input);
            const value = e.target.checked;
            let newOptin = [...optins];
            newOptin[index].value = value;
            updateOptins(newOptin);
        }
    };

    /**
     * Valide une checkbox custom
     */
    const validateOptinField = (input) => (displayError = true) => {
        const { optins } = this.state;
        const index = optins.findIndex((el) => el.id === input);

        if (!optins[index].required) {
            return true;
        }
        const error = Validate("isChecked", optins[index].value);

        if (displayError) {
            let optin = [...optins];
            optin[index].error = error;
            updateOptins(optin);
        }
        return !error;
    };

    /**
     * Valide l'ensemble des checkbox
     */
    useEffect(() => {
        const validateOptins = () => {
            const {ppFilePath, touFilePath} = config.register.opt_ins
            if (ppFilePath && touFilePath) {
                // SPE ESPAGNE RETIRER CGU_ESPANA
                if (config.country === "SPAIN") {
                    return optins.every((el) => this._validateOptinField(el.id)(false)) && cgu_espana;
                } else {
                    return optins.every((el) => this._validateOptinField(el.id)(false))&& gdpr;
                }
            } else {
                return optins.every((el) => this._validateOptinField(el.id)(false));
            }
        };
        updateValidConsent(validateOptins());
    }, [optins, gdpr, cgu_espana, config]);

    useEffect(() => {
        // Optins supplémentaires
        const { opt_ins } = config.register;
        if (opt_ins.custom) {
            updateOptins(
                opt_ins.custom.map((optin) => ({
                    ...optin,
                    value: "",
                    error: "",
                }))
            )
        }

        // Popup sur bouton see-more-button
        const hiddenTextEventListener = (event) => {
            const hiddenText = getNextSibling(event.target, ".hidden-text");
            setNewsletterPopupOpen(true)
            setNewsletterPopupText(hiddenText.innerHTML)
        }
        const seeMoreButtons = document.querySelectorAll(".see-more-button");
        seeMoreButtons.forEach((seeMoreButton) => {
            seeMoreButton.addEventListener("click", hiddenTextEventListener);
        });

        return () => {
            seeMoreButtons.forEach((seeMoreButton) => {
                seeMoreButton.removeEventListener("click", hiddenTextEventListener);
            });
        };
    }, [config, updateOptins]);

    // Affichage optins
    return (
    <div className="optins mt10 optins-container">
        {/* SPE ESPAGNE */}
        {config.country === "SPAIN" &&
        config.register.opt_ins.touFilePath &&
        config.register.opt_ins.ppFilePath && (
        <div className="cgu_register">
            <div className="h4">Información básica de protección de datos</div>
            <p>
                <b>Responsable</b> L’Oréal España, S.A.U.
            </p>
            <p>
                <b>Finalidad:</b> La finalidad principal de tratamiento de sus
                datos personales es cargar su contenido a nuestra página web.
            </p>
            <b>Derechos:</b> Acceder, rectificar y suprimir los datos, así como
            otros derechos, como se explica en la información adicional.
            <p>
                <b>Información adicional: </b> Puede consultar la información
                adicional y detallada sobre Protección de Datos en nuestra{" "}
                <a href={config.register.opt_ins.ppFilePath} target="_blank" rel="noopener noreferrer">
                    Política de Privacidad
                </a>
                .
            </p>
            <div className="ins_input ins_input_checkbox mb20">
                <input id="cgu_espana" name="cgu_espana" onClick={handleOptin("cgu_espana")} type="checkbox" />
                <label htmlFor="cgu_espana">
                    <span>
                        He leído y acepto los&nbsp;
                        <a href="https://master.lorealoneretail.com/uploads/instance/pdf/terminosdeusooneretailpdf"
                            target="_blank" rel="noopener noreferrer">
                            Términos de Uso
                        </a>{" "}
                        y la{" "}
                        <a href="https://master.lorealoneretail.com/uploads/instance/pdf/politicadeprivacidadoneretailepdf"
                            target="_blank" rel="noopener noreferrer">
                            Política de Privacidad
                        </a>{" "}
                        de la web.
                    </span>
                </label>
            </div>
        </div>
        )}
        {config.country === "UNITED KINGDOM" &&
        config.register.opt_ins.ppFilePath && (
        <div className="cgu_register">
            <p>﻿﻿You need to be at least 16 years of age to sign up.</p>

            <p>
                One Retail will use your personal data to manage your account and
                to give you access to the features available on the Platform, for
                analytics, and where you have opted in, to send you
                communications.
            </p>

            <p>
                For more information on how we use your personal data, please see
                our{" "}
                <a href={config.register.opt_ins.ppFilePath} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
            </p>
        </div>
        )}

        {config.country !== "SPAIN" &&
        config.register.opt_ins.touFilePath &&
        config.register.opt_ins.ppFilePath &&
        config.register.opt_ins.ctFilePath && (
        <InsCheckbox label={ <span>
            <Trans i18nKey="optin_gpdr_tou">
                I accept
                <a target="_blank" rel="noopener noreferrer" href={config.register.opt_ins.touFilePath}>
                    the Terms of Use
                </a>
                ,
                <a target="_blank" rel="noopener noreferrer" href={config.register.opt_ins.ppFilePath}>
                    privacy policy
                </a>
                and
                <a target="_blank" rel="noopener noreferrer" href={config.register.opt_ins.ctFilePath}>
                    Community Terms
                </a>
            </Trans>
            {required ? <span className="alert_msg mb10 red bold">{ t("required")}</span> : <></>}
            </span>
            }
            name="gdpr"
            onClick={handleOptin("gdpr")}
        />
        )}
        <div className="custom-optins">
            {optins &&
            optins.map((optin, index) => (
            <>
                <p>{optins}</p>
                <InsCheckbox key={index + optin.id} label={optin.text} name={optin.id} link={optin.filePath}
                    onClick={clickOptin(optin)}
                    />
            </>
            ))}
        </div>
        {config.country === "UNITED KINGDOM" && (
        <div className="custom-label-bottom">
            One Retail is part of L’Oréal UKI.
        </div>
        )}
        <div className="ins_input ins_input_checkbox mb20">
            <input id="newsletter" name="newsletter" onClick={(e) => updateNewsletter(e.target.checked)} type="checkbox" />
            <label htmlFor="newsletter">
                <span dangerouslySetInnerHTML={{ __html: t("optin_newsletter", { interpolation: { escapeValue: false },
                    }), }}></span>
            </label>
            <Popup position="center" open={newsletterPopupOpen} onClose={closePopup}>
                <button className="close-button" onClick={closePopup}>
                    <img src={images.closeCross} alt="" />
                </button>
                <div className="modal">
                    <span dangerouslySetInnerHTML={{ __html: newsletterPopupText, }}></span>
                </div>
            </Popup>
        </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(ConnectOptin));
